/* import __COLOCATED_TEMPLATE__ from './custom-formatters.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';

// Template only components here don't seem to accept arguments,
// but this _is_ the component signature.

// interface Args {
//   formatters: Formatter[];
// }

const CustomFormatters = templateOnlyComponent();
export default CustomFormatters;